import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./popupsright.css";

const apiUrl = process.env.REACT_APP_API_URL;

const formatXp = (value) => Number(value || 0).toLocaleString("ro-RO");

const BoltButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [xpFromStats, setXpFromStats] = useState(0);

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const userRes = await fetch(`${apiUrl}/user`, {
          credentials: "include",
        });

        if (!userRes.ok) return;

        const user = await userRes.json();

        if (!user?.user_id) return;

        const statsRes = await fetch(`${apiUrl}/user/${user.user_id}/stats`, {
          credentials: "include",
        });

        if (!statsRes.ok) return;

        const stats = await statsRes.json();
        setXpFromStats(Number(stats?.xp ?? 0));
      } catch (error) {
        console.error("Eroare la preluarea user_stats:", error);
      }
    };

    fetchUserStats();
  }, []);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-bolt-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={() => setOpen(!open)}
      >
        <span className="first-main-pagi-stats-icon">XP</span>
        <div className="first-main-pagi-stats-number">{formatXp(xpFromStats)}</div>
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-bolt-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
            style={{ minWidth: 220 }}
          >
            <div className="first-main-pagi-popup-header">
              <div className="orientation-title-popup-main">
                <span className="first-main-pagi-stats-icon" style={{fontSize: 22, marginRight: 8}}>XP</span>
                <p className="distance-coin">Sold XP</p>
              </div>
            </div>
            <div className="coin-balance-details">
              <div className="coin-row">
                <span>XP azi:</span>
                <span className="coin-amount">{formatXp(xpFromStats)}</span>
              </div>
              <div className="coin-row">
                <span>XP saptamana aceasta:</span>
                <span className="coin-amount">{formatXp(xpFromStats)}</span>
              </div>
              <div className="coin-row">
                <span>XP total:</span>
                <span className="coin-amount">{formatXp(xpFromStats)}</span>
              </div>
            </div>
            <div className="first-main-pagi-popup-item-xp">
              <span className="color-button-streak">Castiga XP</span>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default BoltButtonWithDropdown;
